// Compute the current YYYY-MM-DD in Europe/Zurich so the client agrees with
// the server's range validation. en-CA renders ISO-style dates.
export function todayInZurich(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Zurich' }).format(now);
}
